package com.macrofocus.eflux.components

import com.macrofocus.common.selection.MutableSingleSelection
import com.macrofocus.common.selection.Selection
import js.objects.unsafeJso
import mui.material.Paper
import mui.material.styles.Theme
import mui.material.styles.useTheme
import mui.system.SxProps
import react.FC
import react.Props
import web.cssom.*

external interface PrimaryInfoProps : Props {
    var probing: MutableSingleSelection<Any>?
    var selection: MutableSingleSelection<Any>?
    var ignoreProbing: Selection<Any>?
    var hideCrossborder: MutableSingleSelection<Any>?
}

val PrimaryInfo = FC<PrimaryInfoProps> { props ->
    val theme = useTheme<Theme>()

    val customBackground: (SxProps<Theme>) -> Unit = { it ->
        it.blurBackground(theme)
    }

    Paper {
        sx = unsafeJso {
            position = Position.relative
            top = 0.px
//                bottom = 0.px
            height = Auto.auto
            asDynamic().minHeight = Length.fitContent
            maxHeight = 100.pct
            left = 0.px
            right = 0.px
            overflowX = Overflow.clip
            overflowY = Auto.auto

            customBackground(this)
        }

        Info {
            primary = true
            probing = props.probing
            selection = props.selection
            ignoreProbing = props.ignoreProbing
            hideCrossborder = props.hideCrossborder
        }
    }
}